import gql from 'graphql-tag';

export const RESULT_QUERY_GET_SESSION_COUNT = gql`
  query getSessionCount($includeEmpty: Boolean, $createdLastNumberOfDays: Int) {
    getSessionCount(includeEmpty: $includeEmpty, createdLastNumberOfDays: $createdLastNumberOfDays)
  }
`;

export const RESULT_QUERY_GET_INSTANCE_COUNT = gql`
  query getInstanceCount($createdLastNumberOfDays: Int) {
    getInstanceCount(createdLastNumberOfDays: $createdLastNumberOfDays)
  }
`;

export const RESULT_QUERY_GET_INSTANCES = gql`
  query getInstances($limit: Int) {
    getInstances(limit: $limit) {
      id
      userId
      totalShots
      createdAt
      updatedAt
      jsonData {
        shootingProgramStatus {
          shootingProgramName
          shooter {
            firstName
            lastName
          }
        }
      }
    }
  }
`;
